import React from 'react'
import { Database } from 'lucide-react'
import GenericTable from '../../components/GenericTable'

const AdminPolicyTypes = () => {
  return (
    <GenericTable
      tableName="policy_types"
      title="Policy Types"
      icon={Database}
      iconColor="cyan"
      searchFields={['product_code', 'product_name', 'product_category', 'product_subcategory', 'product_variant']}
      hiddenFields={['policy_type_id', 'created_at', 'updated_at']}
      primaryKey="policy_type_id"
      defaultFields={['product_code', 'product_name', 'product_category', 'product_subcategory', 'product_variant', 'base_sum_insured_min', 'base_sum_insured_max', 'coverage_percentage', 'status']}
      addFields={['product_code', 'product_name', 'display_name', 'product_description', 'product_category', 'product_subcategory', 'product_variant', 'base_sum_insured_min', 'base_sum_insured_max', 'coverage_percentage']}
      editFields={[
        'product_name', 'display_name', 'product_description', 'product_category', 'product_subcategory', 'product_variant',
        'base_sum_insured_min', 'base_sum_insured_max', 'coverage_percentage', 'deductible_applicable', 'co_payment_applicable',
        'pre_existing_condition_waiting_months', 'maternity_waiting_months', 'min_entry_age_years', 'max_entry_age_years',
        'inpatient_coverage', 'outpatient_coverage', 'day_care_coverage', 'emergency_coverage', 'status'
        // Excluded: policy_type_id, product_code, created_at, updated_at
      ]}
    />
  )
}

export default AdminPolicyTypes
